export const survivalGuideItems = [
    "Read /m/help",
    "light therapy",
    "use heating pad",
    "dump your mind onto the board",
    "increase comfort",
    "Read /r/depressionmeals",
    "walking cane",
    "drink tea/coffee",
    "lower your standards",
    "INTJ Quora bookmarks",
    "pursue fascinations",
    "drone zone",
    "read",
    "isolate + comfort",
    "eat",
    "block/walk away",
    "binaural",
    "create problem in dreams",
    "countheartbeats",
    "use dream decisions (DMF)",
    "putyourfeetup",
    "donothing",
    "write",
    "read JP/CGJ book of mind quotes",
    "Use micro-task checklist",
    "orange light",
    "Half-speed",
    "Give up on the game",
    "practice noscreen (aka burning time)",
    "cut processed foods"
];
